import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function TwoFactorAuth() {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [resendMessage, setResendMessage] = useState("");
  const [isResending, setIsResending] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuth } = useAuth(); // Utiliser le contexte d'authentification

  const email = location.state?.email; // Récupérer l'email depuis l'état de navigation

  const handleVerify = async () => {
    setIsLoading(true);
    setError("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/auth/2fa/verify`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, code }),
          credentials: "include", // Inclure les cookies pour la session
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || t("verification_error"));
      }

      // Mettre à jour le contexte d'authentification
      setAuth(data.user._id, data.user.role, true);

      // Rediriger vers la page des programmes
      navigate("/programs");
    } catch (err) {
      console.error(t("verification_error"), err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendCode = async () => {
    setIsResending(true);
    setResendMessage("");
    setError("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/auth/2fa/resend`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || t("resend_error"));
      }

      setResendMessage(t("resend_success"));
    } catch (err) {
      console.error(t("resend_error"), err);
      setError(err.message);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center h-100">
      <div>
        <h3>{t("2fa_verification")}</h3>
        <Form.Group>
          <Form.Label>{t("enter_code")}</Form.Label>
          <Form.Control
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
        </Form.Group>
        <Button
          onClick={handleVerify}
          className="mt-3"
          disabled={isLoading || !code.trim()}
        >
          {isLoading ? t("verifying") : t("verify_button")}
        </Button>
        <Button
          variant="secondary"
          onClick={handleResendCode}
          className="mt-3 ms-2"
          disabled={isResending}
        >
          {isResending ? t("resending") : t("resend_button")}
        </Button>
        {error && (
          <Alert variant="danger" className="mt-3">
            {error}
          </Alert>
        )}
        {resendMessage && (
          <Alert variant="info" className="mt-3">
            {resendMessage}
          </Alert>
        )}
      </div>
    </div>
  );
}

export default TwoFactorAuth;
